module.exports = __webpack_public_path__ + "static/media/Clock.5c2f30ce.svg";